import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { activityData } from '../../../../hooks/SchoolProfileContext/SchoolProfileSlice';
import ProfileSection from '../ProfileSection';

import styles from './styles.module.css';
import renderListOfActivitiesTypes from '../utils/renderListOfActivitiesTypes';

export default function ExtracurricularActivities({ isFetching }) {
  const [useAllactivities, setUseAllActivities] = useState([]);
  const schoolActivities = useSelector(activityData);
  const [extracurricularActivities, setExtracurricualrActivities] = useState({});
  const [count, setCount] = useState(0);

  const useEffect1 = async () => {
    const artisticActivities = {
      properties: await assignValueById(schoolActivities, 3),
      title: 'Actividades Artísticas',
    };
    const culturalActivities = {
      properties: await assignValueById(schoolActivities, 4),
      title: 'Actividades Culturales',
    };
    const sportActivities = {
      properties: await assignValueById(schoolActivities, 5),
      title: 'Actividades Deportivas',
    };

    const extracurricular = await assignValueById(schoolActivities, 2);
    setExtracurricualrActivities(extracurricular);

    if (culturalActivities.length === 0
      && artisticActivities.length === 0
      && sportActivities.length === 0
    ) {
      setUseAllActivities(null);
    } else {
      setUseAllActivities([
        artisticActivities,
        culturalActivities,
        sportActivities,
      ]);
    }
  };

  useEffect(() => {
    useEffect1();
  }, []);

  useEffect(() => {
    useAllactivities.forEach((activity) => {
      if (activity.properties.length > 0) {
        setCount((prevCount) => prevCount + 1);
      }
    });
  }, [useAllactivities]);

  if (isFetching) {
    return <>...loading</>;
  }
  if (!count) {
    return <>{' '}</>;
  }

  return (
    <ProfileSection
      title="Actividades Extracurriculares"
      subtitleLyrics={{
        subtitle: 'Información sobre las actividades extracurriculares de la Institución',
        lyrics: extracurricularActivities[0]?.description,
      }}
    >
      <div className={styles.sectionsContainer}>
        {
          renderListOfActivitiesTypes(useAllactivities)
        }
      </div>
    </ProfileSection>
  );
}

ExtracurricularActivities.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
